<script lang="ts">
  import { run } from "svelte/legacy";

  import TextInput from "./TextInput.svelte";

  interface Props {
    error?: boolean;
    value: string | undefined;
    lockedValue: string;
    max?: any;
    inputPadding: string;
    required?: boolean;
    hasPressedContinue?: boolean;
  }

  let {
    error = false,
    value = $bindable(),
    lockedValue,
    max = undefined,
    inputPadding,
    required = false,
    hasPressedContinue = false,
  }: Props = $props();

  const removeLockedValue = (inputValue: string): void => {
    if (inputValue != undefined && inputValue.match(lockedValue) && inputValue.length === max - 1) {
      value = inputValue.slice(lockedValue.length);
    }
  };

  $effect(() => {
    removeLockedValue(value ?? "");
  });
</script>

<div class="relative mb-0.5">
  <TextInput {hasPressedContinue} {error} {max} class="flex {inputPadding}" {required} bind:value />
  <div
    class="absolute inset-y-0 flex bg-Neutral200 px-1.5 rounded-l-md {!error && value !== undefined
      ? 'border-t border-b border-l border-Neutral400'
      : ''}"
  >
    <span class="text-Neutral900 rounded-md-l pt-px m-auto">{lockedValue}</span>
  </div>
</div>
